<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :modal="false" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="积分：" prop="point">
                <el-input v-model="model.point"></el-input>
                <span class="tips">输入正/负整数</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark"></el-input>
                <span class="tips">该备注前后端用户均能看到，请认真填写</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'memberPointLogEdit',
    mixins: [editutil],
    props: {
        member_id: {
            type: Number,
            default() {
                return -1;
            }
        },
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.resetModel(this.form_name);
                this.loadData();
            }
        }
    },
    data() {
        return {
            model: {
                member_id: '',
                email: '',
                income_state: '',
                income_type: '',
                point: '',
                data_id: '',
                remark: '',
                add_time: '',
            },
            getObj:{
                url:'/api/admin/memberpointlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                point: [
                    {required: true, message: '积分不能为空', trigger: 'blur'}
                ],
                remark: [
                    {required: true, message: '备注不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/memberpointlog/save'
                    }
                    this.model.member_id = this.member_id
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>